import { PublicationOption } from 'types';

export const securitelOption: PublicationOption = {
  active: true,
  checked: true,
  duration: 30,
  id: 'PO_SECURITEL',
  label: 'Sécuritel',
  price: 0,
  priceHT: 0,
  publicationOptions: ['SECURITEL'],
  relatedOffers: [],
  template: 'securitel',
  vat: 0,
  name: 'securitel',
  text: 'Votre numéro de téléphone est remplacé par un numéro de substitution qui redirigera vos appels',
  title: 'Option Sécuritel',
  order: 3,
};

export const defaultPublicationOption: Partial<PublicationOption>[] = [
  {
    name: 'priorisation',
    label: 'Option Priorisation - 30 jours',
    text: 'Votre annonce remonte dans les listes de résultats pendant 30 jours.',
    order: 0,
    picture: 'priorisation',
    template: 'pole_position',
  },
  {
    name: 'points_forts',
    label: 'Option Points Forts - 30 jours',
    text: 'To be replaced',
    order: 1,
    picture: 'points_forts',
    template: 'strengths',
  },
  {
    name: 'pack',
    label: 'Pack 2 options - 30 jours',
    text: 'Donnez la meilleure visibilité à votre annonce pendant 30 jours.',
    title: 'Priorisation + Points forts',
    order: 2,
    picture: 'priorisation',
    picture2: 'points_forts',
    template: 'pack_prio_and_strengths',
  },
];
